import gql from 'graphql-tag';

const CAMPAIGN_ORDER_TRANSACTIONS_ALL_PAGINATED = gql`
  query campaignOrderTransactionsAllPaginated(
    $where: CampaignOrderTransactionsWithEventsWhereInput!
    $first: Int
    $skip: Int
    $orderBy: CampaignOrderTransactionsWithEventsOrderByInput
  ) {
    campaignOrderTransactionsWithEventsesConnection(
      first: $first
      skip: $skip
      orderBy: $orderBy
      where: $where
    ) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          orderId
          adProviderId
          totalImpressions
          revenue
          lastImpression
          transactionDate
          attrMethod
          attrValue
          attrWindow
          impressions(orderBy: impressionTime_DESC) {
            id
            eventId
            media
            creativeId
            creativeName
            impressionTime
            impressionPublisherPlatform
            impressionPublisherUrl
            impressionPublisher
            impressionPublisherMedia
            impressionPubliserViewed
            additionalInfo {
              id
              impressionDSP
              impressionPublisherID
              impressionPublisherDomain
              lineItemID
              insertionOrderId
              publisherAppStore
              publisherAppName
              siteId
              siteName
              publisherID
              publisherName
            }
          }
        }
      }
    }
  }
`;

export default CAMPAIGN_ORDER_TRANSACTIONS_ALL_PAGINATED;
